import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import { createOfficialNotesDetailsValidationSchema } from "../../../../../../yup/officialNotes/officialNotesValidationSchemas";
import { completeNoteStep, setStepNoteEdited } from "../../../../../../store/redux/slice/Forms/officialNotesForm";
import NoteDetailsFormSection from "./section/NoteDetailsFormSection";
import useFormReset from "../../../../../../hooks/useFormReset";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import { initialOfficialNotesDetails } from "../../../../../../init/officialNotesInitialValues";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import OfficialNotesFeesSection from "./section/OfficialNoresFeesSection";
import NoteApplicationDetailsFormSection from "./section/NoteApplicationDetailsFormSection";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import React from "react";

const OfficialNotesStepNote = () => {
  const { t } = useTranslation();

  const officialNotesForm = useAppSelector((state) => {
    return state.Forms.OfficialNotesForm;
  });

  const fullSchema = createOfficialNotesDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    officialNotesForm.officialNotesDetails,
    officialNotesForm.id,
    baseEndpointPaths.officialNotes,
    formalSchema,
    setStepNoteEdited,
    completeNoteStep,
    initialOfficialNotesDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.OFFICIAL_NOTE, officialNotesForm.officialNotesDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
            console.log(errors);
          })}
        >
          <OfficialNotesFeesSection />
          <NoteApplicationDetailsFormSection />
          <NoteDetailsFormSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};

export default OfficialNotesStepNote;
